import React from 'react';
import ReactCountryFlag from "react-country-flag"
import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';

const Holdings = ({ rows, info }) => {
    const [pageSize, setPageSize] = React.useState(10);

    const columns = [
        {
            field: 'Name',
            headerName: 'Company',
            renderCell: (params) => (
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center'
                }}>
                    <Box sx={{ mr: 1 }}>{params.value}</Box>
                    <ReactCountryFlag countryCode={params.row.Location} />
                </Box>
            ),
            flex: 1
        },
        {
            field: 'Weight1',
            headerName: info.length ? `Weight in ${info[0].Ticker}` : 'Weight',
            valueFormatter: (params) => `${params.value}%`,
            type: 'number',
            headerAlign: 'center',
            flex: 0.3
        },
        {
            field: 'Weight2',
            headerName: info.length ? `Weight in ${info[1].Ticker}` : 'Weight',
            valueFormatter: (params) => `${params.value}%`,
            type: 'number',
            headerAlign: 'center',
            flex: 0.3
        },
        {
            field: 'OverlapWeight',
            headerName: 'Overlap',
            valueFormatter: (params) => `${params.value}%`,
            type: 'number',
            headerAlign: 'center',
            flex: 0.3
        },
    ];

    return (
        <DataGrid
            getRowId={(row) => row.Name}
            rows={rows}
            columns={columns}
            density="compact"
            autoHeight={true}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[10, 25, 100]}
            pagination
        />
    );
}

export default Holdings;